import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarLandingComponent } from './pages/calendar-landing/calendar-landing.component';
import { PropertyCalendarComponent } from './pages/property-calendar/property-calendar.component';
import { CalendarModeGuard } from '@app/modules/calendar/guards/calendar-mode.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'occupancy',
    pathMatch: 'full',
  },
  {
    path: ':mode',
    component: CalendarLandingComponent,
    canActivate: [CalendarModeGuard],
    data: {
      title: 'Calendar',
    },
  },
  {
    path: 'property/:id',
    component: PropertyCalendarComponent,
    data: {
      shouldReuse: false,
    },
  },
  {
    path: 'm',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CalendarRoutingModule {}
